<app-inline-loader></app-inline-loader>

<div appVerifyVehicleCta>
  @switch (slice?.type) {
    @case ('hero') {
      <app-slice-hero-section [vehicleObject]="vehicleObject" [slice]="slice" (emitOpenModal)="openModal($event)"></app-slice-hero-section>
    }
    @case ('plans') {
      <app-slice-plans [slice]="slice" [vehicleObject]="vehicleObject" (emitOpenModal)="openModal($event)"></app-slice-plans>
    }
    @case ('content_block') {
      <app-slice-content-block [slice]="slice" [vehicleObject]="vehicleObject" (emitOpenModal)="openModal($event)"></app-slice-content-block>
    }
    @case ('faq') {
      <app-slice-faq [vehicleObject]="vehicleObject" [slice]="slice" (emitOpenModal)="openModal($event)"></app-slice-faq>
    }
    @case ('product') {
      <app-slice-product [slice]="slice" [vehicleObject]="vehicleObject" (emitOpenModal)="openModal($event)"></app-slice-product>
    }
    <!-- <pre *ngSwitchCase="'content_block'" > {{slice | json}}</pre> -->
    <!-- <app-slice-features *ngSwitchCase="'worry-free-protection'" [slice]="slice" [vehicleObject]="vehicleObject"></app-slice-features>
    <app-slice-facts *ngSwitchCase="'rev-vsp-info-cards'" [slice]="slice" [vehicleObject]="vehicleObject"></app-slice-facts>
    <app-slice-how-it-works *ngSwitchCase="'coverage-beyond-warranty'" [slice]="slice" [vehicleObject]="vehicleObject"></app-slice-how-it-works>
    <app-slice-benefits *ngSwitchCase="'benefits'" [slice]="slice" [vehicleObject]="vehicleObject"></app-slice-benefits>
    <app-slice-lifestyle *ngSwitchCase="'lifestyle'" [slice]="slice" [vehicleObject]="vehicleObject"></app-slice-lifestyle>
    <app-slice-all-features-include *ngSwitchCase="'all_features_include'" [slice]="slice" [vehicleObject]="vehicleObject"></app-slice-all-features-include>
    <app-slice-choose-your-coverage *ngSwitchCase="'choose_your_coverage'" [slice]="slice" [vehicleObject]="vehicleObject"></app-slice-choose-your-coverage>
    <app-slice-related-products *ngSwitchCase="'related_products'" [slice]="slice" [vehicleObject]="vehicleObject"></app-slice-related-products> -->
  }
</div>
